<div class="filter-tag"  *ngIf="control.value !== defaultValue">
    {{title}}{{label ? ' : ' + label:''}} <a (click)="onClickResetControl($event)" class="remove" title="Eliminar">×</a>
</div>
